import { motion } from "framer-motion";
import Layout from "../../containers/Layout";
import BoxInfoTemplate from "../BoxInfoTEmplate/BoxInfoTemplate";
import HorizontalCardPricesInmersion from "../HorizontalCardPricesInmersion/HorizontalCardPricesInmersion";
import Seo from "../Seo/Seo";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const Immersion = () => {
  return (
    <Layout mt={16}>
      <Seo
        title="Eclipse Immersion 2026 — Learn Spanish in Galicia"
        description="Join the Eclipse Immersion 2026: total Spanish language immersion in Galicia, Spain, under a total solar eclipse. Cultural excursions and group lessons."
        path="/immersion-2026"
      />
      <BoxInfoTemplate
        title="Learn Spanish in Galicia"
        subTitle="Eclipse Immersion 2026"
        mainText="Experience total language immersion under a total solar eclipse."
        iconType="sun"
        showQuotes={false}
        showShadow={true}
        borderColor="green"
      />

      <div style={{ textAlign: "left", padding: "1rem 0" }}>
        {/* Introductory Sentence */}
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          style={{
            fontSize: "1.2rem",
            fontWeight: "500",
            marginBottom: "2rem",
          }}
        >
          I want to invite you to discover A Mariña Lucense, while you learn
          Spanish.
        </motion.p>

        {/* YouTube Video Section */}
        <motion.section
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          style={{ marginBottom: "2rem" }}
        >
          <div
            style={{
              position: "relative",
              paddingBottom: "56.25%",
              height: 0,
              overflow: "hidden",
              borderRadius: "8px",
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/16ZPdpVCBEE"
              title="Discover A Mariña Lucense"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
            />
          </div>
        </motion.section>

        {/* Overview Section */}
        <motion.section
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          style={{ marginBottom: "2rem" }}
        >
          <h2>Overview</h2>
          <p>
            Join me in <strong>Foz, Galicia (Spain)</strong> for a seven-day
            Spanish immersion retreat. Improve your conversational skills and
            cultural knowledge in an authentic setting.
          </p>
        </motion.section>

        {/* Where Section with Google Map */}
        <motion.section
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          style={{ marginBottom: "2rem" }}
        >
          <h2>Location</h2>
          <div
            style={{
              margin: "1rem auto",
              width: "60%",
              borderRadius: 8,
              overflow: "hidden",
            }}
          >
            <iframe
              title="Foz, Galicia Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1152675.0864031352!2d-7.642062354654486!3d43.731797060783855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd322805904ee353%3A0xff1aae7e1fa89536!2sFoz%2C%20Lugo!5e1!3m2!1ses!2ses!4v1754490873569!5m2!1ses!2ses"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
            />
          </div>

          <p>
            Foz is a coastal town in the Mariña Lucense, with nearby excursions
            to Burela, Viveiro, Ribadeo and prime viewing sites for the eclipse
            in 2026.
          </p>
        </motion.section>

        {/* When Section */}
        <motion.section
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          style={{ marginBottom: "2rem" }}
        >
          <h2>Dates</h2>
          <p>
            <strong>July 13–19, 2026</strong>
            <br />
            <strong>August 11–17, 2026</strong> (Total eclipse viewing on August
            12)
            <br />
            <strong>September 15–21, 2026</strong>
          </p>
          <p style={{ marginTop: "1rem" }}>
            Reservations open in <strong>November 2025</strong>.<br />
            Subscribe to the newsletter to get early access.
            <br />
            <strong>Limited spots available!</strong>
          </p>
        </motion.section>

        {/* Level Section */}
        <motion.section
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          style={{ marginBottom: "2rem" }}
        >
          <h2>All Levels</h2>
          <p>(A1–C2)</p>
        </motion.section>

        {/* Included Section */}
        <motion.section
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          style={{ marginBottom: "2rem" }}
        >
          <h2>What’s Included</h2>
          <ul>
            <li>Daily group Spanish classes (2h/day)</li>
            <li>Language exchange sessions</li>
            <li>Cultural workshops and guided excursions</li>
            <li>Eclipse viewing with live commentary</li>
            <li>Certificate of completion</li>
            <li>Pre-arrival online orientation</li>
          </ul>
        </motion.section>

        {/* Activities Section */}
        <motion.section
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          style={{ marginBottom: "2rem" }}
        >
          <h2>Sample Activities</h2>
          <ul>
            <li>Guided coastal and forest walks</li>
            <li>Galician cultural introductions</li>
            <li>Optional paddleboarding and market visits</li>
          </ul>
        </motion.section>

        {/* Add-ons Section */}
        <motion.section
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          style={{ marginBottom: "2rem" }}
        >
          <h2>Optional Add-ons</h2>
          <ul>
            <li>Accommodation in Foz (from €60/night per person)</li>
            <li>Local meals (from €15/meal per person)</li>
            <li>Airport transfers (Asturias or Santiago: €150)</li>
          </ul>
        </motion.section>

        {/* Audience Section */}
        <motion.section
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          style={{ marginBottom: "2rem" }}
        >
          <h2>Who Is This For?</h2>
          <p>
            Ideal for motivated learners seeking immersive practice in a
            distinctive cultural and natural setting.
          </p>
        </motion.section>

        {/* Pre-register Section */}
        <motion.section
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.9 }}
          style={{ marginBottom: "2rem" }}
        >
          <h2>Reserve Your Spot</h2>
          <p>
            Limited spaces available.Price for a tailor-made program for a
            minimum of 2 students. Price will vary based on number of students,
            time of year, included lessons/activities and number of days
          </p>
          <p style={{ marginTop: "1rem" }}>
            ❗ Flights and insurance are not included.
          </p>
        </motion.section>

        {/* Closing Note */}
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 1.0 }}
          style={{
            fontStyle: "italic",
            fontSize: "1.1rem",
            marginBottom: "2rem",
          }}
        >
          Let’s make language learning unforgettable.
        </motion.p>

        {/* Pricing Card */}
        <HorizontalCardPricesInmersion />
      </div>
    </Layout>
  );
};

export default Immersion;
